import { Component } from '@angular/core';
import { DetailInfoTypeComponent } from '../detail-info-type.component';

@Component({
    selector: 'detail-info-textarea',
    templateUrl: './detail-info-textarea.component.html',
    standalone: false
})
export class DetailInfoTextareaComponent extends DetailInfoTypeComponent {
  ngOnInit() {
    super.ngOnInit();
  }
}